/* Stealth Ride side cart: related-parts dropdowns, lazy rows, order note, shipping estimate (+ tracking), toggles, discount code. No libraries. */
(function () {
  if (window.__srSideCart) return;
  window.__srSideCart = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'NZD';
  var KLAVIYO_COMPANY = 'WYHfDV';
  var KLAVIYO_LIST = 'UeKi9f';
  var TTL = 10 * 60 * 1000;
  var ROW_MAX = 6;
  var REL_MAX = 20;
  /* Top 5 shipping countries by orders (last 12 months) - shown first in the list */
  var TOP_COUNTRIES = ['New Zealand', 'Australia', 'United States', 'Canada', 'United Kingdom'];
  /* Countries where Starshipit quotes without a region */
  var NO_REGION = { 'New Zealand': 1 };
  var mem = {};
  var pendingMsg = null;
  var openRel = {};
  var openTool = {};
  var noteTimer = null;
  var lastShipHTML = '';

  function cartEl() { return document.getElementById('mini-cart'); }
  function q(sel) { return document.querySelector('#mini-cart ' + sel); }
  function isOpen() { var c = cartEl(); return !!c && c.getAttribute('aria-hidden') === 'false'; }
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  function cacheGet(k) {
    if (mem[k] !== undefined) return mem[k];
    try {
      var o = JSON.parse(sessionStorage.getItem('srsc:' + k) || 'null');
      if (o && Date.now() - o.t < TTL) { mem[k] = o.h; return o.h; }
    } catch (e) {}
    return null;
  }
  function cacheSet(k, h) {
    mem[k] = h;
    try { sessionStorage.setItem('srsc:' + k, JSON.stringify({ t: Date.now(), h: h })); } catch (e) {}
  }
  function getHTML(url, key) {
    var c = cacheGet(key);
    if (c !== null) return Promise.resolve(c);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { cacheSet(key, t); return t; })
      .catch(function () { return ''; });
  }
  function rowCards(html, row) {
    if (!html) return [];
    var d = document.createElement('div');
    d.innerHTML = html;
    var r = d.querySelector('[data-sr-row="' + row + '"]');
    return r ? Array.prototype.slice.call(r.querySelectorAll('[data-sr-card]')) : [];
  }
  function fillStrip(strip, cards, used, max) {
    strip.innerHTML = '';
    var n = 0;
    cards.forEach(function (c) {
      var pid = c.getAttribute('data-pid');
      if (n >= max || used[pid]) return;
      used[pid] = 1;
      strip.appendChild(c);
      n++;
    });
    return n;
  }
  function cartInfo() {
    var box = cartEl() && cartEl().querySelector('[data-sr-upsells]');
    var ids = box ? (box.getAttribute('data-cart-ids') || '') : '';
    var inCart = {};
    ids.split(',').forEach(function (id) { if (id) inCart[id] = 1; });
    return { box: box, ids: ids, inCart: inCart, cust: box ? (box.getAttribute('data-cust') || 'guest') : 'guest' };
  }
  function postJSON(path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
  }
  function closeCart() {
    var t = document.querySelector('[data-action="toggle-mini-cart"][aria-expanded="true"]') || document.querySelector('[data-action="toggle-mini-cart"]');
    if (t) t.click();
  }

  /* ---------- Rows under the items: wish list, Popular items, Grab these too ---------- */
  function loadRows() {
    if (!isOpen()) return;
    var info = cartInfo();
    var box = info.box;
    if (!box || box.hasAttribute('data-sr-loaded')) return;
    box.setAttribute('data-sr-loaded', '');
    getHTML(ROOT + '?section_id=sr-cart-upsells', info.cust + ':rows:' + info.ids).then(function (html) {
      if (!box.isConnected) return;
      var used = Object.assign({}, info.inCart);
      ['wishlist', 'popular', 'addons'].forEach(function (slot) {
        var el = box.querySelector('[data-sr-slot="' + slot + '"]');
        if (!el) return;
        el.hidden = fillStrip(el.querySelector('.sr-sc__strip'), rowCards(html, slot), used, ROW_MAX) === 0;
      });
    });
  }

  /* ---------- Related parts dropdown on each cart item ---------- */
  function panelFor(btn) {
    var li = btn.closest('.mini-cart__line-item');
    var p = li && li.nextElementSibling;
    return p && p.hasAttribute('data-sr-rel-panel') ? p : null;
  }
  function setRel(btn, open) {
    var panel = panelFor(btn);
    if (!panel) return;
    var handle = btn.getAttribute('data-sr-rel');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) openRel[handle] = 1; else delete openRel[handle];
    if (!open || panel.hasAttribute('data-sr-loaded')) return;
    panel.setAttribute('data-sr-loaded', '');
    var strip = panel.querySelector('.sr-sc__strip');
    strip.innerHTML = '<p class="sr-rel__note">Loading related parts...</p>';
    var info = cartInfo();
    getHTML(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=sr-item-related', info.cust + ':rel:' + handle).then(function (html) {
      if (!strip.isConnected) return;
      var n = fillStrip(strip, rowCards(html, 'related'), Object.assign({}, info.inCart), REL_MAX);
      if (!n) strip.innerHTML = '<p class="sr-rel__note">No related parts in stock right now.</p>';
    });
  }
  function restoreRel() {
    Array.prototype.forEach.call(document.querySelectorAll('#mini-cart [data-sr-rel]'), function (btn) {
      if (openRel[btn.getAttribute('data-sr-rel')] && btn.getAttribute('aria-expanded') !== 'true') setRel(btn, true);
    });
  }

  /* ---------- Order note / Estimate shipping links ---------- */
  function setTool(name, open) {
    var btn = q('[data-sr-tool="' + name + '"]');
    var panel = q('[data-sr-tool-panel="' + name + '"]');
    if (!btn || !panel) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
    if (open) openTool[name] = 1; else delete openTool[name];
    if (open && name === 'ship') primeShip();
  }
  function restoreTools() {
    Object.keys(openTool).forEach(function (name) {
      var btn = q('[data-sr-tool="' + name + '"]');
      if (btn && btn.getAttribute('aria-expanded') !== 'true') setTool(name, true);
    });
  }

  function saveNote(text) {
    var msg = q('[data-sr-note-msg]');
    if (msg) msg.textContent = 'Saving...';
    postJSON('cart/update.js', { note: text }).then(function (r) {
      if (!r.ok) throw r;
      var m = q('[data-sr-note-msg]');
      if (m) m.textContent = text ? 'Note saved. It will be on your order.' : 'Note removed.';
      var b = q('[data-sr-tool="note"]');
      if (b) b.textContent = text ? 'Edit order note' : 'Add order note';
    }).catch(function () {
      var m = q('[data-sr-note-msg]');
      if (m) m.textContent = "Couldn't save your note. Please try again.";
    });
  }

  /* ---------- Shipping estimate ---------- */
  function shipSaved() { try { return JSON.parse(lsGet('sr_ship') || '{}'); } catch (e) { return {}; } }
  function hasOption(sel, v) { return Array.prototype.some.call(sel.options, function (o) { return o.value === v && !o.disabled; }); }
  function prepCountries(sel) {
    if (!sel || sel.hasAttribute('data-sr-prepped')) return;
    sel.setAttribute('data-sr-prepped', '');
    Array.prototype.slice.call(sel.options).forEach(function (o) { if (!o.value || o.value === '---') o.remove(); });
    var moved = 0;
    TOP_COUNTRIES.forEach(function (name) {
      var o = Array.prototype.filter.call(sel.options, function (x) { return x.value === name; })[0];
      if (o) { sel.insertBefore(o, sel.options[moved]); moved++; }
    });
    if (moved && sel.options.length > moved) {
      var sep = document.createElement('option');
      sep.disabled = true;
      sep.textContent = '──────────';
      sel.insertBefore(sep, sel.options[moved]);
    }
  }
  function syncProvince() {
    var c = q('[data-sr-ship-country]');
    var p = q('[data-sr-ship-province]');
    if (!c || !p) return;
    var opt = c.options[c.selectedIndex];
    var list = [];
    try { list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]'); } catch (e) {}
    var need = list.length > 0 && !NO_REGION[c.value];
    if (p.getAttribute('data-for') !== c.value) {
      p.innerHTML = '<option value="">State / region</option>' + list.map(function (x) { return '<option value="' + esc(x[0]) + '">' + esc(x[1] || x[0]) + '</option>'; }).join('');
      p.setAttribute('data-for', c.value);
    }
    p.style.display = need ? '' : 'none';
  }
  function primeShip() {
    var s = shipSaved();
    var c = q('[data-sr-ship-country]');
    var p = q('[data-sr-ship-province]');
    var city = q('[data-sr-ship-city]');
    var z = q('[data-sr-ship-zip]');
    var list = q('[data-sr-ship-results]');
    if (c && !c.hasAttribute('data-sr-prepped')) {
      prepCountries(c);
      var pick = [s.country, c.getAttribute('data-default'), 'New Zealand'].filter(function (v) { return v && hasOption(c, v); })[0];
      if (pick) c.value = pick;
    }
    syncProvince();
    if (p && s.province && !p.value && hasOption(p, s.province)) p.value = s.province;
    if (city && s.city && !city.value) city.value = s.city;
    if (z && s.zip && !z.value) z.value = s.zip;
    /* the cart can re-render after an estimate - keep the last result on screen */
    if (list && !list.innerHTML && lastShipHTML) list.innerHTML = lastShipHTML;
  }
  function money(amount, cur) {
    var n = Number(amount);
    if (!n) return 'Free';
    try { return new Intl.NumberFormat('en-NZ', { style: 'currency', currency: cur || CURRENCY }).format(n); } catch (e) { return '$' + n.toFixed(2); }
  }
  function showRates(list, html, keep) {
    lastShipHTML = keep ? html : '';
    if (list) list.innerHTML = html;
  }
  function checkoutFallback(detail) {
    return '<li class="sr-sc__ship-fail">' +
      (detail ? '<span class="sr-sc__ship-fail-detail">' + esc(detail) + '</span>' : '') +
      '<strong>We couldn\'t get a shipping price for that address here.</strong>' +
      '<span>Head to checkout to see every delivery option and the exact cost for your address. You won\'t be charged until you place your order.</span>' +
      '<a class="sr-sc__ship-checkout" href="' + ROOT + 'checkout">See shipping at checkout &rarr;</a>' +
      '</li>';
  }

  /* Tracking: Klaviyo "Estimated Shipping" event (identified visitors), Shopify customer event, and a hidden
     cart attribute so orders that used the estimate show "_Shipping estimate" in Shopify admin. */
  function trackEstimate(addr, result, rates) {
    var cheapest = rates && rates.length ? rates[0] : null;
    fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var props = {
        country: addr.country, region: addr.province || '', city: addr.city, postcode: addr.zip,
        result: result,
        rates_count: rates ? rates.length : 0,
        cheapest_rate: cheapest ? Number(cheapest.price) : null,
        cheapest_option: cheapest ? (cheapest.presentment_name || cheapest.name) : '',
        cart_value: cart.total_price / 100,
        currency: cart.currency,
        item_count: cart.item_count,
        items: (cart.items || []).slice(0, 15).map(function (i) { return i.product_title; }),
        skus: (cart.items || []).slice(0, 15).map(function (i) { return i.sku; }),
        product_ids: (cart.items || []).map(function (i) { return i.product_id; }),
        page: location.pathname
      };
      try {
        if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track('Estimated Shipping', props);
        else (window._learnq = window._learnq || []).push(['track', 'Estimated Shipping', props]);
      } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sr_shipping_estimate', props); } catch (e) {}
      var summary = addr.city + ' ' + addr.zip + ', ' + addr.country + ' - ' + (cheapest ? money(cheapest.price, cheapest.currency) + ' ' + (cheapest.presentment_name || cheapest.name) : 'no rate (' + result + ')');
      postJSON('cart/update.js', { attributes: { '_Shipping estimate': summary } });
    }).catch(function () {});
  }

  function estimateShipping() {
    var c = q('[data-sr-ship-country]');
    var p = q('[data-sr-ship-province]');
    var cityEl = q('[data-sr-ship-city]');
    var z = q('[data-sr-ship-zip]');
    var btn = q('[data-sr-ship-go]');
    var list = q('[data-sr-ship-results]');
    var country = c ? c.value : 'New Zealand';
    var needRegion = p && p.style.display !== 'none';
    var province = needRegion ? p.value : '';
    var city = cityEl ? cityEl.value.trim() : '';
    var zip = z ? z.value.trim() : '';
    var err = function (t) { showRates(list, '<li class="sr-sc__ship-note sr-sc__ship-note--error">' + t + '</li>'); };
    if (!country) return err('Choose your country.');
    if (needRegion && !province) return err('Choose your state or region.');
    if (!city) return err('Enter your suburb or town.');
    if (!zip) return err('Enter your postcode.');
    var addr = { country: country, province: province, city: city, zip: zip };
    lsSet('sr_ship', JSON.stringify(addr));

    var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=' + encodeURIComponent(country) + '&shipping_address[province]=' + encodeURIComponent(province) + '&shipping_address[city]=' + encodeURIComponent(city);
    if (btn) btn.disabled = true;
    showRates(list, '<li class="sr-sc__ship-note">Getting live rates...</li>');

    function done() { var b = q('[data-sr-ship-go]'); if (b) b.disabled = false; }
    function out(html) { showRates(q('[data-sr-ship-results]'), html, true); }
    function fail(e) {
      var detail = '';
      if (e && typeof e === 'object' && !(e instanceof Response)) {
        var parts = [];
        Object.keys(e).forEach(function (k) { var v = e[k]; parts.push((k === 'zip' ? 'Postcode' : k.charAt(0).toUpperCase() + k.slice(1)) + ' ' + (Array.isArray(v) ? v.join(', ') : v)); });
        if (parts.length) detail = parts.join('. ') + '.';
      }
      out(checkoutFallback(detail));
      trackEstimate(addr, detail ? 'address_error' : 'error', []);
      done();
    }
    function render(rates) {
      if (!rates.length) { out(checkoutFallback('')); trackEstimate(addr, 'no_rates', []); return done(); }
      rates.sort(function (a, b) { return Number(a.price) - Number(b.price); });
      out(rates.map(function (r) {
        return '<li class="sr-sc__ship-rate"><span>' + esc(r.presentment_name || r.name) + '</span><strong>' + esc(money(r.price, r.currency)) + '</strong></li>';
      }).join('') + '<li class="sr-sc__ship-note">Final shipping is confirmed at checkout. Free pickup from Petone is also available at checkout.</li>');
      trackEstimate(addr, 'rates', rates);
      done();
    }
    function poll(n) {
      fetch(ROOT + 'cart/async_shipping_rates.json?' + qs, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { if (r.status === 422 || (j && j.error)) throw (j.errors || j); return j; }); })
        .then(function (j) {
          if (j && j.shipping_rates) return render(j.shipping_rates);
          if (n < 20) setTimeout(function () { poll(n + 1); }, 600);
          else fail(null);
        }).catch(fail);
    }
    fetch(ROOT + 'cart/prepare_shipping_rates.json?' + qs, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (r.ok) return poll(0);
        return r.json().then(function (j) { throw j; }, function () { throw null; });
      }).catch(fail);
  }

  /* ---------- Discount code ---------- */
  function setMsg(text, error) {
    pendingMsg = { text: text, error: !!error, until: Date.now() + 6000 };
    showPendingMsg();
  }
  function showPendingMsg() {
    if (!pendingMsg) return;
    if (Date.now() > pendingMsg.until) { pendingMsg = null; return; }
    var el = q('[data-sr-discount-msg]');
    if (!el || el.textContent === pendingMsg.text) return;
    el.textContent = pendingMsg.text;
    el.className = 'sr-sc__discount-msg' + (pendingMsg.error ? ' sr-sc__discount-msg--error' : '');
  }
  function currentCodes() {
    return Array.prototype.slice.call(document.querySelectorAll('#mini-cart [data-sr-code]')).map(function (el) { return el.getAttribute('data-sr-code'); });
  }
  function setCodes(codes) {
    return postJSON('cart/update.js', { discount: codes.join(',') }).then(function (r) { return r.json(); });
  }
  function applyCode() {
    var input = q('[data-sr-discount-input]');
    var btn = q('[data-sr-discount-apply]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var existing = currentCodes();
    if (btn) btn.disabled = true;
    setCodes(existing.concat([code])).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) {
        setMsg('Code ' + hit.code.toUpperCase() + ' applied.', false);
        refreshCart();
      } else {
        setMsg("That code isn't valid for the items in your cart.", true);
        if (btn) btn.disabled = false;
        return setCodes(existing);
      }
    }).catch(function () {
      setMsg("Couldn't apply that code. Please try again.", true);
      if (btn) btn.disabled = false;
    });
  }

  /* ---------- VIP deals sign-up (Klaviyo Newsletter list) ---------- */
  function mktMsg(text, error) {
    var el = q('[data-sr-mkt-msg]');
    if (!el) return;
    el.textContent = text;
    el.className = 'sr-sc__mkt-msg' + (error ? ' sr-sc__mkt-msg--error' : '');
  }
  function subscribe(email) {
    var toggle = q('[data-sr-mkt-toggle]');
    if (toggle) toggle.disabled = true;
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: {
        custom_source: 'Side cart',
        profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } })
    }).then(function (r) {
      if (!r.ok) throw r;
      lsSet('sr_mkt_done', '1');
      var form = q('[data-sr-mkt-form]');
      if (form) form.hidden = true;
      mktMsg("You're in. Watch your inbox for member-only deals.", false);
    }).catch(function () {
      if (toggle) { toggle.disabled = false; toggle.checked = false; }
      mktMsg("Couldn't sign you up. Please check your email and try again.", true);
    });
  }
  function submitMktForm() {
    var input = q('[data-sr-mkt-email]');
    var email = input ? input.value.trim() : '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { mktMsg('Please enter a valid email.', true); return; }
    subscribe(email);
  }
  function hideMktIfDone() {
    if (lsGet('sr_mkt_done') !== '1') return;
    var w = q('[data-sr-mkt]');
    if (w && !w.querySelector('[data-sr-mkt-toggle]:checked')) w.hidden = true;
  }

  /* ---------- Clicks / changes / typing ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-sr-sc-close]')) { e.preventDefault(); closeCart(); return; }

    var rel = t.closest('[data-sr-rel]');
    if (rel) { e.preventDefault(); setRel(rel, rel.getAttribute('aria-expanded') !== 'true'); return; }

    var tool = t.closest('[data-sr-tool]');
    if (tool) { e.preventDefault(); var name = tool.getAttribute('data-sr-tool'); setTool(name, tool.getAttribute('aria-expanded') !== 'true'); return; }

    if (t.closest('[data-sr-ship-go]')) { e.preventDefault(); estimateShipping(); return; }

    var add = t.closest('[data-sr-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      add.textContent = 'Adding...';
      postJSON('cart/add.js', { items: [{ id: Number(add.getAttribute('data-vid')), quantity: 1 }] }).then(function (r) {
        if (!r.ok) throw r;
        refreshCart();
      }).catch(function () { add.textContent = 'Unavailable'; });
      return;
    }

    if (t.closest('[data-sr-discount-apply]')) { e.preventDefault(); applyCode(); return; }
    if (t.closest('[data-sr-mkt-submit]')) { e.preventDefault(); submitMktForm(); return; }

    var rm = t.closest('[data-sr-discount-remove]');
    if (rm) {
      e.preventDefault();
      var code = rm.getAttribute('data-sr-discount-remove');
      setCodes(currentCodes().filter(function (c) { return c !== code; })).then(function () {
        setMsg('Code removed.', false);
        refreshCart();
      });
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-sr-note]')) return;
    e.stopPropagation();
    var m = q('[data-sr-note-msg]');
    if (m) m.textContent = '';
    clearTimeout(noteTimer);
    var text = t.value;
    noteTimer = setTimeout(function () { noteTimer = null; saveNote(text); }, 700);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;

    if (t.matches('[data-sr-note], [data-sr-ship-zip], [data-sr-ship-city], [data-sr-ship-province], [data-sr-discount-input], [data-sr-mkt-email]')) { e.stopPropagation(); return; }
    if (t.matches('[data-sr-ship-country]')) { e.stopPropagation(); syncProvince(); showRates(q('[data-sr-ship-results]'), ''); return; }

    if (t.matches('[data-sr-protection]')) {
      e.stopPropagation();
      t.disabled = true;
      var vid = t.getAttribute('data-vid');
      var req = t.checked
        ? postJSON('cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] })
        : postJSON('cart/change.js', { id: String(vid), quantity: 0 });
      req.then(refreshCart).catch(function () { t.disabled = false; t.checked = !t.checked; });
      return;
    }

    if (t.matches('[data-sr-mkt-toggle]')) {
      e.stopPropagation();
      var wrap = t.closest('[data-sr-mkt]');
      var form = wrap && wrap.querySelector('[data-sr-mkt-form]');
      mktMsg('', false);
      if (!t.checked) { if (form) form.hidden = true; return; }
      var known = wrap && wrap.getAttribute('data-email');
      if (known) { subscribe(known); }
      else if (form) { form.hidden = false; var i = form.querySelector('input'); if (i) i.focus(); }
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches) return;
    if (e.target.matches('[data-sr-discount-input]')) { e.preventDefault(); applyCode(); }
    else if (e.target.matches('[data-sr-mkt-email]')) { e.preventDefault(); submitMktForm(); }
    else if (e.target.matches('[data-sr-ship-zip], [data-sr-ship-city]')) { e.preventDefault(); estimateShipping(); }
  });

  /* Save a half-typed note if the cart closes or the page is left */
  function flushNote() {
    if (!noteTimer) return;
    clearTimeout(noteTimer);
    noteTimer = null;
    var t = q('[data-sr-note]');
    if (t) saveNote(t.value);
  }
  window.addEventListener('pagehide', flushNote);

  function onChange() {
    var open = isOpen();
    document.documentElement.classList.toggle('sr-sc-lock', open);
    if (open) { loadRows(); restoreRel(); restoreTools(); showPendingMsg(); hideMktIfDone(); }
    else flushNote();
  }

  function init() {
    var c = cartEl();
    if (!c || !window.MutationObserver) return;
    var timer = null;
    var mo = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; onChange(); }, 30);
    });
    mo.observe(c.parentNode, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    onChange();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
